








































import { Component, Prop, Vue } from 'vue-property-decorator';

import SystemMessage from './Message/SystemMessage.vue';
import SystemNotice from './Message/SystemNotice.vue';
import ChatMessageSwitch from './Message/ChatMessageSwitch.vue';

import { BaseEvent, MessageListItem } from '@/common/bot/types';
import { ItemType } from '@/common/bot/lib';
import { emit } from 'process';
import { emitArticleAutocompleteCollapse } from '@/common/eventBus';

@Component({
  components: {
    SystemMessage,
    ChatMessageSwitch,
    SystemNotice,
  },
})
export default class MessageList extends Vue {
  @Prop({ default: () => [] }) readonly messages!: MessageListItem[];
  @Prop({ default: () => [] }) readonly stickyMessages!: MessageListItem[];
  @Prop({ default: 60 }) readonly paddingBottom!: number;

  /**
   * Forward message events to parent component.
   */
  proxyMessageEvent ($event: BaseEvent) {
    this.$emit('message:input', $event);
  }

  readonly isMessage = ItemType.isMessage;
  readonly isNotice = ItemType.isNotice;

  startingScrollPosition: number | null = null;

  handleScroll (e: UIEvent) {
    const SCROLL_DELTA = 100;

    const target = e.target as HTMLElement;
    const currentScrollPosition = target.scrollTop;

    if (this.startingScrollPosition === null) {
      this.startingScrollPosition = currentScrollPosition;
    }

    const delta = currentScrollPosition - this.startingScrollPosition;

    if (delta < 0) {
      this.startingScrollPosition = currentScrollPosition;
      return;
    }

    if (delta >= SCROLL_DELTA) {
      emitArticleAutocompleteCollapse(true);
      this.startingScrollPosition = currentScrollPosition;
    }
  }

  updated () {
    this.scrollToEnd(this.messages?.length <= 1);
  }

  scrollToEnd (toTop = false) {
    const container = (this.$refs.container as HTMLDivElement);
    container.scrollTop = toTop ? 0 : container.scrollHeight;
  }
}
